import React from 'react'

const ViewSeller = () => {
  return (
    <div>ViewSeller</div>
  )
}

export default ViewSeller